import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../../reducers';

export const getLiteralsState = createSelector(getDragonflySharedState, (state) => state.literals);

export const getTagAssignment = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.system.tagassignment'],
);

export const getTagType = createSelector(getLiteralsState, ({ literals }) => literals['liquid.tags.type']);

export const getTagCode = createSelector(getLiteralsState, ({ literals }) => literals['liquid.tags.code']);

export const getTagLabel = createSelector(getLiteralsState, ({ literals }) => literals['liquid.tags.label']);

export const getTagCreate = createSelector(getLiteralsState, ({ literals }) => literals['liquid.tags.create']);

export const getTagUpdate = createSelector(getLiteralsState, ({ literals }) => literals['liquid.tags.update']);

export const getTagBrandCode = createSelector(getLiteralsState, ({ literals }) => literals['liquid.brand.brandcode']);

export const getTagBrandName = createSelector(getLiteralsState, ({ literals }) => literals['liquid.brand.brandname']);

export const getTagEdit = createSelector(getLiteralsState, ({ literals }) => literals['liquid.localestrings.edit']);

export const getTagInactive = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.tagmanagement.column.inactive'],
);

export const getTagStartDate = createSelector(getLiteralsState, ({ literals }) => literals['liquid.tags.startdate']);

export const getTagEndDate = createSelector(getLiteralsState, ({ literals }) => literals['liquid.tags.enddate']);

export const getIsActive = createSelector(getLiteralsState, ({ literals }) => literals['liquid.tagmanagement.active']);

export const getIsInactive = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.tagmanagement.inactive'],
);

export const getTagCreated = createSelector(getLiteralsState, ({ literals }) => literals['liquid.tag.created']);

export const getTagsUpdated = createSelector(getLiteralsState, ({ literals }) => literals['liquid.tags.msg.updated']);
